import { config } from "@/config";

const menuItems = [
	{
		label: "Home",
		isHovered: false,
		routeName: ["Homepage"],
		hoverIcon: "dashboardachover.svg",
		activeIcon: "dashboardin.svg",
		icon: "dashboardac.svg",
		childRoutes: [],
		onClick: (router) => {
			router.push({ name: "Homepage" });
		},
	},
	{
		label: "Resume Builder",
		isHovered: false,
		routeName: ["CandidateDashboard"],
		hoverIcon: "resume-builder-hover.svg",
		activeIcon: "resume-builder-sel.svg",
		icon: "resume-builder.svg",
		childRoutes: [],
		onClick: (router) => {
			router.push({ name: "CandidateDashboard" });
		},
	},
	{
		label: "Assessments",
		isHovered: false,
		routeName: ["AssessmentMarketplace", "CandidateAssessmentProgress"],
		hoverIcon: "asmntproginactivehover.svg",
		activeIcon: "asmntprogactive.svg",
		icon: "asmntproginactive.svg",
		childRoutes: [],
		onClick: (router, route) => {
			let navigate = {
				name: "AssessmentMarketplace",
			};
			if (route.name === "CandidateDashboard" && route.query.status) {
				navigate.query = {
					status: route.query.status,
				};
			}
			router.push(navigate);
		},
	},
	{
		label: "Jobs",
		isHovered: false,
		hoverIcon: "jobUnselhover.svg",
		activeIcon: "jobSel.svg",
		icon: "jobUnsel.svg",
		showChildRoutes: false,
		childRoutes: [
			{
				label: "Job Search",
				isHovered: false,
				routeName: ["JobSearch"],
				onClick: (router) => {
					router.push({
						name: "JobSearch",
						query: {},
					}).catch((err) => {
						if (err.name !== "NavigationDuplicated") throw err;
					});
				},
			},
			{
				label: "Applied Jobs",
				isHovered: false,
				routeName: ["JobProgress"],
				onClick: (router) => {
					router.push({
						name: "JobProgress",
						query: {
							screen: "main-screen",
							from: "sidebar",
						},
					}).catch((err) => {
						if (err.name !== "NavigationDuplicated") throw err;
					});
				},
			},
			{
				label: "Saved Jobs",
				isHovered: false,
				routeName: ["JobSearch"],
				onClick: (router) => {
					router.replace({
						name: "JobSearch",
						query: {
							bookmarked: true,
							screen: "saved-jobs",
							from: "sidebar",
						},
					}).catch((err) => {
						if (err.name !== "NavigationDuplicated") throw err;
					});
				},
			},
		],
	},
	{
		label: "Training",
		isHovered: false,
		hoverIcon: "Training-Hover.svg",
		activeIcon: "Training-Sel.svg",
		icon: "Training-Unsel.svg",
		showChildRoutes: false,
		childRoutes: [
			{
				label: "Market Place",
				isHovered: false,

				onClick: () => {
					window.location.href = `${config.trainingBase}/marketplace`;
				},
			},
			{
				label: "Dashboard",
				isHovered: false,

				onClick: () => {
					window.location.href = `${config.trainingBase}/dashboard`;
				},
			},
			{
				label: "Community",
				isHovered: false,

				onClick: () => {
					window.location.href = `${config.trainingBase}/community`;
				},
			},
			{
				label: "Certificates",
				isHovered: false,

				onClick: () => {
					window.location.href = `${config.trainingBase}/certificate`;
				},
			},
			{
				label: "Instructors",
				isHovered: false,

				onClick: () => {
					window.location.href = `${config.trainingBase}/instructors`;
				},
			},
		],
	},
	{
		label: "Upload Documents",
		isHovered: false,
		routeName: ["CandidateDocsList"],
		hoverIcon: "documentsinactivehover.svg",
		activeIcon: "documentsactive.svg",
		icon: "documentsinactive.svg",
		childRoutes: [],
		onClick: (router) => {
			router.push({
				name: "CandidateDocsList",
			});
		},
	},
	{
		label: "My Interview",
		isHovered: false,
		hoverIcon: "interHover.svg",
		activeIcon: "interSel.svg",
		icon: "interUnsel.svg",
		showChildRoutes: false,
		childRoutes: [
			{
				label: "Panel Dashboard",
				isHovered: false,
				routeName: ["PanelDashboard"],
				onClick: (router) => {
					router.push({
						name: "PanelDashboard",
					});
				},
			},
			{
				label: "Transactions",
				isHovered: false,
				routeName: ["Transaction"],
				onClick: (router) => {
					router.push({ name: "Transaction" });
				},
			},
		],
	},
	// {
	// 	label: "Profile Visibility",
	// 	isHovered: false,
	// 	routeName: ["ProfileVisibility"],
	// 	hoverIcon: "documentsinactivehover.svg",
	// 	activeIcon: "documentsactive.svg",
	// 	icon: "documentsinactive.svg",
	// 	childRoutes: [],
	// 	onClick: (router) => {
	// 		router.push({
	// 			name: "ProfileVisibility",
	// 		});
	// 	},
	// },
];

export default menuItems;
